<template>
	<LayoutForm>
		<h1 slot="header">Create MADD</h1>

		<FormStepNav
            slot="nav"
            :total-steps="totalSteps"
            :current-step="currentStep"
            :completed-step="completedStep"
            :route-base="routeBase"
        />

		<MADDFormStep1 v-if="currentStep === 1" />
		<MADDFormStep2 v-if="currentStep === 2" />
		<MADDFormStep3 v-if="currentStep === 3" />
		<MADDFormStep4 v-if="currentStep === 4" />
	</LayoutForm>
</template>

<script>
	import API from '../../api';
	import LayoutForm from '../Layout/LayoutForm';
	import MADDFormStep1 from './Form/MADDFormStep1';
	import MADDFormStep2 from './Form/MADDFormStep2';
	import MADDFormStep3 from './Form/MADDFormStep3';
	import MADDFormStep4 from './Form/MADDFormStep4';
	import MultiStepForm from '../Form/MultiStepForm';
	import FormStepNav from '../Form/FormStepNav';

	export default {
		name: 'MADDForm',
		mixins: [MultiStepForm],
		components: {
			FormStepNav,
			MADDFormStep1,
			MADDFormStep2,
			MADDFormStep3,
			MADDFormStep4,
			LayoutForm,
		},
		data() {
			return {
				totalSteps: 4,
				routeBase: (this.id) ? `/madds/${ this.id }/edit` : '/madds/create',
			}
		},
		methods: {
			fetchResource(id) {
				return API.getMADD(id);
			},
			sanitizeResource(madd) {
				this.$store.commit('selectCache/addUser', madd.lead);
				madd.lead = madd.lead.id;

				if(Array.isArray(madd.team)) {
					madd.team = madd.team.map(member => {
						this.$store.commit('selectCache/addUser', member);
						return member.id;
					});
				}

				// if(Array.isArray(madd.sectors)) {
				// 	madd.sectors = madd.sectors.map(sector => {
				// 		return sector.id;
				// 	});
				// }

                madd.primarySector = madd.primarySector && madd.primarySector.id
                    ? madd.primarySector.id
                    : null;
				madd.dealType = madd.dealTypeId;
				madd.transactionCurrency = madd.currencyId;
				madd.showTransactionValue = !!madd.showTransactionValue;
				madd.membersOnly = !!madd.membersOnly;

				return madd;
			},
		},
	}
</script>
